import { TEXT_STYLES } from '../../constants/styles';

function ProjectOverview({ title = 'Overview', paragraphs = [], liveUrl }) {
  if (!paragraphs || paragraphs.length === 0) return null;

  return (
    <div className="space-y-6">
      <div className="prose prose-lg">
        {title && (
          <h2 className={TEXT_STYLES.subheading + ' mb-2'}>
            {title}
          </h2>
        )}
        {paragraphs.map((paragraph, index) => (
          <p 
            key={index}
            className={`${TEXT_STYLES.body} ${index < paragraphs.length - 1 ? 'mb-6' : ''}`}
          >
            {paragraph}
          </p>
        ))}
        {liveUrl && (
          <a
            href={liveUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-[#0D0D0D] text-white text-sm font-medium rounded-full hover:bg-[#333333] transition-colors"
          >
            View Live Site
            <svg 
              className="w-4 h-4" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
              />
            </svg>
          </a>
        )}
      </div>
    </div>
  );
}

export default ProjectOverview;

